export const ADMIN_LIST_USERS_LOADED = 'admin-list-users-loaded'
export const UPDATE_ADMIN_LIST_USERS_LOAD_STATUS =
  'update-admin-list-users-load-status'
export const ADMIN_SHOW_USER_LOADED = 'admin-show-user-loaded'
export const UPDATE_ADMIN_SHOW_USER_LOAD_STATUS =
  'update-admin-show-user-load-status'
